<div class="flex items-center">
    <ng-container *ngIf="battery && battery.batteryConnected">
        <h6 *ngIf="showPercentage" class="m-b0 m-r2 battery-text gray-mid-text">{{ battery.level }}%</h6>
        <span class="normal-size" *ngIf="showBatteryIcon" [ngClass]="batteryClass">
            <span *ngIf="pathClassRequired" class="path1"></span>
            <span *ngIf="pathClassRequired" class="path2"></span>
        </span>
    </ng-container>
</div>
